import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { faHandPointer } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  return (
    <div className={classnames(component)}>
      <div className='row'>
        <div className='country-name inline instructions'>
          <p className='tap-icon'><FontAwesomeIcon icon={faHandPointer} /></p>
          <p>
            <small>Tap to know more</small>
          </p>
        </div>
        <div className='cases-trend trend inline'>
          <p>Infections</p>
          <p><small>% of peak</small></p>
        </div>
        <div className='deaths-trend trend inline'>
          <p>Deaths</p>
          <p><small>% of peak</small></p>
        </div>
        <div className='vaccinated inline'>
          <p className='desktop'>Percent of population given at least one dose of vaccine</p>
          <p className='mobile'>Percent given at least 1 dose of vaccine</p>
        </div>
        <div className='phase-progress inline'>
          <p>Vaccination phase</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
